module.exports = __webpack_public_path__ + "img/loe_Portrett3.92b71a95.jpg";